export class CreateCloudEnvironmentDialogData {
  accountId?: string;
  deploymentTypes?: string[];
  defaultDeploymentType?: string;
  environmentVersions?: string[];
}